import { LogManager } from "../../log/log.manager";
import * as i0 from "@angular/core";
import * as i1 from "./system.configuration.service";
var BaseSystemConfigurationValues = /** @class */ (function () {
    function BaseSystemConfigurationValues(cfg) {
        this.cfg = cfg;
        this.LIST_SEPERATOR = ',';
    }
    BaseSystemConfigurationValues.prototype.getNumber = function (key, defaultVal) {
        var stringVal = this.getValidatedString(key, "" + defaultVal);
        if (isNaN(+stringVal)) {
            var err = "cannot parse number value for " + key + ". Value is " + stringVal;
            LogManager.error("ConfigItem", err);
            throw new Error(err);
        }
        else {
            return +stringVal;
        }
    };
    BaseSystemConfigurationValues.prototype.getBoolean = function (key, defaultVal) {
        var stringVal = this.getValidatedString(key, "" + defaultVal);
        switch (stringVal.toUpperCase()) {
            case "T":
            case "Y":
            case "TRUE":
            case "YES":
                return true;
            case "F":
            case "N":
            case "FALSE":
            case "NO":
                return false;
            default: {
                throw new Error("cannot parse boolean value for " + key + ". Value is " + stringVal);
            }
        }
    };
    BaseSystemConfigurationValues.prototype.getNumberArray = function (key, defaultVal) {
        var stringVal = this.getValidatedString(key, "" + defaultVal);
        if (!stringVal) {
            return [];
        }
        return stringVal.split(this.LIST_SEPERATOR).map(function (strVal) { return +strVal; });
    };
    BaseSystemConfigurationValues.prototype.getValidatedString = function (key, defaultVal) {
        var cfgVal = this.cfg.getConfigByKey(key);
        if (!cfgVal && defaultVal) {
            var err = "invalid cfg requested <" + key + ">. value is missing.";
            LogManager.warn("ConfigItem", err);
            return defaultVal;
        }
        if (!cfgVal || cfgVal.status === "NotValid") {
            var err = "invalid cfg requested <" + key + ">. value is not valid.";
            LogManager.error("ConfigItem", err);
            if (defaultVal) {
                return defaultVal;
            }
            throw new Error(err);
        }
        return cfgVal.value;
    };
    BaseSystemConfigurationValues.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BaseSystemConfigurationValues_Factory() { return new BaseSystemConfigurationValues(i0.ɵɵinject(i1.SystemConfigurationService)); }, token: BaseSystemConfigurationValues, providedIn: "root" });
    return BaseSystemConfigurationValues;
}());
export { BaseSystemConfigurationValues };
